export default __webpack_public_path__ + "static/media/japangot-screenshot-06.6a44a29f.png";